import { useMenuStore } from 'vince-core/stores/menuStore';
import { useUserStore } from 'vince-core/stores/userStore';
import { Menu, SubHeader } from 'vince-core/types/menu';

export default defineNuxtPlugin(() => {
    const store = useMenuStore();
    const userStore = useUserStore();
    store.addMenuItem('mcpPermissions.menu', '/mcp-permissions', 5, Menu.ADMINISTRATION, SubHeader.ADMINISTRATION, 'pi pi-shield', () => !!userStore.userInfo?.isVinceLiveAdmin);
});
